import classNames from "classnames";
import { DetailedHTMLProps, FC, TextareaHTMLAttributes } from "react";
import styles from "./Textarea.module.scss";

interface TextareaProps
  extends DetailedHTMLProps<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  label?: string;
  labelClassName?: string;
  error?: string;
}

const Textarea: FC<TextareaProps> = ({
  label,
  className,
  labelClassName,
  error,
  ...rest
}) => {
  return (
    <div className={styles.input_container}>
      {label && (
        <label className={classNames(styles.label, labelClassName)}>
          {label}
        </label>
      )}
      <textarea
        rows={3}
        className={classNames(styles.input, className)}
        {...rest}
      ></textarea>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default Textarea;
